import React, { useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";

import { WEB_URL } from "../../../api/URLs";
import { getPercentage } from "../../../helpers";
import useStyles from "./styles/RightColumnStyles";
import { fundRaiserPageAction } from "../../../store/actions";
import { donationConstants } from "../../../store/actionTypes";
import { DonationList, MixPanelTrackedLink, ProgressBar } from "../../../components";
import { InviteTeamMemberModal, ShareFundraiserModal, WarningModal } from "../../../components/modals";
import { CLOSED_PAGE, DONATIONS_LIST_TYPE, DRAFT_PAGE, GTM_EVENTS, TEAM_PAGE } from "../../../constants";

export function RightColumn() {

    const dispatch = useDispatch();
    const donationsLimit = 10;
    const donationsOffset = 0;
    const classes = useStyles();
    const { HIGHEST_DONATIONS, RECENT_DONATIONS } = DONATIONS_LIST_TYPE;
    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details);
    const highestDonations = useSelector(state => state.get_all_fundraiser_page_most_donations.highestDonations.donations);
    const highestDonationsCount = useSelector(state => state.get_all_fundraiser_page_most_donations.highestDonations.totalDonations)
    const recentDonations = useSelector(state => state.get_all_fundraiser_page_mostrecent_donations.recentDonations.donations);
    const recentDonationsCount = useSelector(state => state.get_all_fundraiser_page_mostrecent_donations.recentDonations.totalDonations);
    const user = useSelector(state => state.authentication.user);
    const [warningMessage, setWarningMessage] = useState("");
    const [selectedTab, setSelectedTab] = useState(RECENT_DONATIONS);
    const [openShareModal, setOpenShareModal] = useState(false);
    const [openWarningModal, setOpenWarningModal] = useState(false);
    const [openInvitationModal, setOpenInvitationModal] = useState(false);
    const currencySymbol = pageDetails.symbol_left == "$" ? pageDetails.symbol_left : pageDetails.symbol_left + " ";
    const fundRaised = pageDetails.total_fund_goal_millions;
    const amountWithCurrencySymbol = currencySymbol + fundRaised;
    const totalDonations = pageDetails.count_donations;
    const fundRaisedPercentage = getPercentage(pageDetails.total_fund_raised, pageDetails.fundraising_goal);

    const donationText = totalDonations > 1 ? 'donations' : 'donation';

    const handleShareClick = () => {
        pageDetails.status == DRAFT_PAGE ?
            setWarningMessage("Please publish the page before sharing") :
            setOpenShareModal(true);
    };
    const handleInviteMemberClick = () => {
        pageDetails.status == DRAFT_PAGE ?
            setWarningMessage("Please publish the page before inviting new team members") :
            setOpenInvitationModal(true);
    };
    const getRedirectLink = () => {
        return pageDetails.status !== DRAFT_PAGE ?
            WEB_URL.FUNDRAISER_CHECKOUT(pageDetails.event_id) + "?cntry=" + pageDetails.country_id + "&crncy=" + pageDetails.currency_id
            : null

    };
    const displayInviteButton = () => {
        return pageDetails.user_id == user.id && pageDetails.status !== CLOSED_PAGE &&
            pageDetails.page_type == TEAM_PAGE
    };

    const changeTab = () => {
        switch (selectedTab) {
            case HIGHEST_DONATIONS:
                setSelectedTab(RECENT_DONATIONS)
                break;

            case RECENT_DONATIONS:
                setSelectedTab(HIGHEST_DONATIONS)
                break;

            default:
                break;
        }
    }

    const loadHighestDonations = () => {
        dispatch(fundRaiserPageAction.getFundraiserMostDonated(pageDetails.id, donationsLimit, donationsOffset));
    }

    const loadRecentDonations = () => {
        dispatch(fundRaiserPageAction.getFundraiserRecentDonations(pageDetails.id, donationsLimit, donationsOffset));
    }

    const getImpactMessage = () => {
        return !pageDetails.product_impact.product_impact ?
            <span>Donate and help bring education to deserving children</span> :
            <span>
                Supporting the education of <b>{pageDetails.product_impact.product_impact}</b> {pageDetails.product_impact.product_impact && pageDetails.product_impact.product_impact > 1 ? ' children' : ' child'}
            </span>
    }

    useEffect(() => {
        warningMessage && setOpenWarningModal(true);
    }, [warningMessage])

    useEffect(() => {
        !openWarningModal && setWarningMessage(null)
    }, [openWarningModal])

    useEffect(() => {
        if (pageDetails) { loadHighestDonations(); loadRecentDonations(); }
    }, [pageDetails])

    return <React.Fragment>
        <div className="donation-box">
            <div className="donation-box-inn">
                <div className="donation-amount">{pageDetails.symbol_left}{pageDetails.symbol_left !== "$" && " "}{(donationConstants.AMOUNT_FORMAT.includes(pageDetails.code) ? pageDetails.total_fund_raised.toLocaleString('de-DE') : pageDetails.total_fund_raised.toLocaleString())}</div>
                <div className="donation-goal">
                    raised of {amountWithCurrencySymbol} from <b>{totalDonations}</b> {donationText}
                </div>
                <ProgressBar percentage={fundRaisedPercentage} className={classes.progressBar} />
                <div className="campaign-progress-record">
                    <div className="cam-pro-rec-top">
                        {pageDetails.show_impact_message == 1 && <div className="cam-pro-rec-top-left">
                            {
                                !pageDetails.is_special ? (pageDetails.product_impact ?
                                    getImpactMessage() :

                                    'Donate and help bring education to deserving children'
                                ) :
                                    'Your donation supports the flood relief affectees in Pakistan'
                            }
                        </div>
                        }
                        {/* <HelmetMetaData page_type={share_title} fundraiser_creator_name={fundraiser_creator_name} currentUrl={share_url} quote={quote} image={cover_image} description={description_rendered} title={share_title} ></HelmetMetaData> */}


                    </div>
                    <div className="cam-pro-rec-bottom">
                        <div className="donation-btn-area">
                            <MixPanelTrackedLink
                                type="button"
                                variant="contained"
                                label="Share"
                                color="secondary"
                                context={`${pageDetails.page_title} details page`}
                                className={classes.shareButton}
                                onClick={handleShareClick}
                                gtmEvent={GTM_EVENTS.FUNDRAISER_SHARED}
                                gtmProps={{
                                    fundrasier_name: pageDetails.page_title,
                                    raised_amount: pageDetails.total_fund_raised,
                                    number_of_donation: pageDetails.count_donations,
                                    goal_amount: pageDetails.fundraising_goal
                                }}
                            >Share</MixPanelTrackedLink>
                            <WarningModal open={openWarningModal} setOpen={setOpenWarningModal} message={warningMessage} />
                            {(
                                pageDetails.status === CLOSED_PAGE
                                    ?
                                    <div className="page-closed">
                                        <Typography>
                                            This fundraiser is now closed. Please <MixPanelTrackedLink type="link" label="click here" href={WEB_URL.FUNDRAISER_LISTING} underline="none">click here</MixPanelTrackedLink> to view other fundraisers you can support.
                                        </Typography>
                                    </div>
                                    :
                                    <MixPanelTrackedLink
                                        type="button"
                                        label="Donate Now"
                                        variant="contained"
                                        color="primary"
                                        className={classes.cardButtons}
                                        context={`${pageDetails.page_title} details page`}
                                        href={getRedirectLink()}
                                        gtmProps={{
                                            fundrasier_name: pageDetails.page_title,
                                            raised_amount: pageDetails.total_fund_raised,
                                            number_of_donation: pageDetails.count_donations,
                                            goal_amount: pageDetails.fundraising_goal
                                        }}
                                        gtmEvent={GTM_EVENTS.DONATE_NOW_CLICKED}
                                        onClick={() => pageDetails.status == DRAFT_PAGE && setWarningMessage("Please publish the page to accept donations")}
                                    >Donate now</MixPanelTrackedLink>
                            )}
                            {
                                displayInviteButton() &&
                                <MixPanelTrackedLink
                                    type="button"
                                    variant="contained"
                                    label="Invite a team member"
                                    color="primary"
                                    context="Invite a team member"
                                    className={classes.cardButtons}
                                    onClick={handleInviteMemberClick}
                                >Invite a team member</MixPanelTrackedLink>}
                        </div>
                    </div>
                </div>

                {
                    selectedTab == HIGHEST_DONATIONS && <div id="recentDonationsDiv" className="donations-list">
                        <DonationList donations={highestDonations} totalDonations={highestDonationsCount} listType={HIGHEST_DONATIONS} targetDiv="recentDonationsDiv" />
                    </div>
                }

                {
                    selectedTab == RECENT_DONATIONS && <div id="topDonationsDiv" className="donations-list">
                        <DonationList donations={recentDonations} totalDonations={recentDonationsCount} listType={RECENT_DONATIONS} targetDiv="topDonationsDiv" />
                    </div>
                }

                <MixPanelTrackedLink
                    type="button"
                    label="See recent donations"
                    context="See recent donations"
                    variant="outlined"
                    color="neutral"
                    onClick={changeTab}
                    fullWidth
                >
                    {selectedTab == HIGHEST_DONATIONS ? 'See recent donations' : 'See top donations'}
                </MixPanelTrackedLink>
            </div>

        </div>
        <InviteTeamMemberModal openModal={openInvitationModal} setOpenModal={setOpenInvitationModal} />
        <ShareFundraiserModal openModal={openShareModal} setOpenModal={setOpenShareModal} />
    </React.Fragment>
}